import domEmit from './_domEmit';
import subscriberEmit from './_subscriberEmit';

export default function(type, payload){
    this.log("event", type, payload)
    domEmit(type, payload)
    subscriberEmit.call(this, type, payload)
}